const SECTION_EMOJIS = [
  "🍽️", "✨", "🍷", "💬", "⚠️", "⚠", "🎯", "💡", "⭐", "🔥", "👌",
  "🍴", "🥂", "🌿", "🧄", "🫒", "🍋", "🌶️", "🧅", "🧂",
  "🥩", "🍤", "🫙", "🥗", "🍜", "🍝", "🍛", "🥘", "🧆",
  "🫕", "🎶", "🏆", "📝", "🤝", "👏", "🌟", "💎", "🥄",
  "🫧", "🍃", "🌸", "🍯", "🥞", "🧇", "🥐", "🍞", "🥖",
  "📋", "🧭", "✅", "📌", "📍", "🗣️", "🎤",
];

const SPACER_HTML = '<div style="height:6px;display:block;"></div>';

const injectSectionSpacing = (html = "") => {
  const emojiPattern = SECTION_EMOJIS
    .map((e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|");
  const emojiRe = new RegExp(`(${emojiPattern})`, "gi");

  let flat = html
    .replace(/<\/(div|p)>\s*<(div|p)[^>]*>/gi, "<br>")
    .replace(/<\/?(div|p)[^>]*>/gi, "")
    .replace(/(<br\s*\/?>(\s|&nbsp;)*){2,}/gi, "<br>")
    .replace(/\s*<br\s*\/?>\s*/gi, "<br>")
    .replace(/\n+/g, " ")
    .trim();

  const parts = flat.split(emojiRe);
  if (parts.length <= 1) return html;

  let result = parts[0];
  for (let i = 1; i < parts.length; i += 2) {
    const emoji = parts[i];
    const content = (parts[i + 1] || "").replace(/^(<br\s*\/?>)+/i, "");
    if (i === 1) {
      result += emoji + content;
    } else {
      result += `<br>${SPACER_HTML}` + emoji + content;
    }
  }

  return result;
};

export const formatFlashcardDisplayHtml = (raw = "") => {
  let html = String(raw || "")
    .replace(/```html|```/gi, "")
    .replace(/\\r\\n|\\n|\\r/g, "<br>")
    .replace(/\r\n|\n|\r/g, "<br>")
    .replace(/\\'/g, "'")
    .replace(/\\"/g, '"')
    .trim();

  if (!html) return "";
  return injectSectionSpacing(html);
};
